/** Show forked-from only when source is not the immediate previous version. */
export const shouldShowForkedFrom = (
  versionNumber: number,
  parentVersionNumber: number | null | undefined,
): parentVersionNumber is number =>
  parentVersionNumber !== null &&
  parentVersionNumber !== undefined &&
  versionNumber - parentVersionNumber > 1;
